import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:4000';

const api = axios.create({
  baseURL: API_BASE,
  headers: { 'Content-Type': 'application/json' },
});

api.interceptors.request.use((cfg) => {
  const token = localStorage.getItem('admin_token');
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

export default api;

export const adminLogin = (payload) => api.post('/rockstar/auth/login', payload);

export const getDeposits = () => api.get('/rockstar/admin/deposits');
// export const getDepositById = (id) => api.get(`/rockstar/admin/deposits/${id}`);
export const approveDeposit = (id) => api.post(`/rockstar/admin/deposits/${id}/approve`);
export const rejectDeposit = (id) => api.post(`/rockstar/admin/deposits/${id}/reject`);

export const getKycList = () => api.get('/rockstar/admin/kyc');
export const approveKyc = (id, data) => api.patch(`/rockstar/admin/kyc/${id}/approve`, data);
export const rejectKyc = (id, data) => api.patch(`/rockstar/admin/kyc/${id}/reject`, data);

export const getUsers = () => api.get('/rockstar/admin/users');
export const getUser = (id) => api.get(`/rockstar/admin/users/${id}`);
// if using axios instance `api` that sets Content-Type to json, create a helper:
export const createUser = (formData) =>
  api.post('/rockstar/admin/users/create-user', formData);


  export const getDashboardCounts = () => api.get("/rockstar/admin/dashboard/counts");

  export const getTransactions = () => api.get("/rockstar/admin/transactions");

// ================== Packages ==================
export const getPackages = () =>
  api.get("/rockstar/admin/packages/list");

// export const createPackage = (payload) =>
//   api.post("/rockstar/admin/packages/add", payload);

export const createPackage = ({ noteText, imageUrl }) =>
  api.post(
    "/rockstar/admin/packages/add",
    { noteText, imageUrl },
    {
      headers: {
        "Content-Type": "application/json",
      },
      withCredentials: true, // if using cookie-based admin auth
    }
  );


export const deletePackage = (id) =>
  api.delete(`/rockstar/admin/packages/${id}`);

export const updatePackage = (id, payload) =>
  api.put(`/rockstar/admin/packages/${id}`, payload);

// ================== Settings (logos etc.) ==================
export const getSettings = () =>
  api.get("/rockstar/admin/settings");

export const saveSetting = (key, value) =>
  api.post("/rockstar/admin/settings", { key, value });

export const uploadLogo = (formData) =>
  api.post("/rockstar/admin/settings/upload", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });

  export const getLogs = () => api.get("/rockstar/admin/logs"); 


// ================== Profits (Admin) ==================

// Create profit for a user by rockstarId
export const createProfit = (rockstarId, payload) =>
  api.post(`/rockstar/admin/profits/user/${encodeURIComponent(rockstarId)}/add`, payload);

// Get profits for a specific user by rockstarId
export const getProfitsForUser = (rockstarId) =>
  api.get(`/rockstar/admin/profits/user/${encodeURIComponent(rockstarId)}`);

// Get all profits (paginated, admin view)
export const getAllProfits = (page = 1, limit = 20) =>
  api.get(`/rockstar/admin/profits/all?page=${page}&limit=${limit}`);

// Get a single profit by its ID
export const getProfitById = (id) =>
  api.get(`/rockstar/admin/profits/${encodeURIComponent(id)}`);

// Revoke / delete a profit by its ID
export const revokeProfit = (id) =>
  api.delete(`/rockstar/admin/profits/${encodeURIComponent(id)}`);


// ================== Deposits (Admin) ==================

// Get deposits for a user (admin) by rockstarId
export const getDepositsForUser = (rockstarId) =>
  api.get(`/rockstar/admin/deposits/user/${encodeURIComponent(rockstarId)}`);

// Get a single deposit by id (admin)
export const getDepositById = (id) =>
  api.get(`/rockstar/admin/deposits/${encodeURIComponent(id)}`);

// Approve a deposit (admin)
export const approveDepositAdmin = (id) =>
  api.post(`/rockstar/admin/deposits/${encodeURIComponent(id)}/approve`);

// Reject a deposit (admin)
export const rejectDepositAdmin = (id, body = {}) =>
  api.post(`/rockstar/admin/deposits/${encodeURIComponent(id)}/reject`, body);




/* ---------------- PROFILE (NEW) ---------------- */
export const getAdminProfile = () => api.get('/rockstar/admin/profile');
export const updateAdminProfile = (formData) => api.patch('/rockstar/admin/profile/update', formData, { headers: { 'Content-Type': 'multipart/form-data' } });

// =============================
// FAQ CATEGORY API ENDPOINTS
// =============================

// Create (Add) FAQ Category
export const createFaqCategory = (data) => {
  // expects { name: "Category Name" }
  return api.post("/rockstar/admin/faq-category", data);
};

// Get All FAQ Categories (Admin)
export const getAllFaqCategoriesAdmin = (params = {}) => {
  // optional params: { limit, offset, search, includeInactive }
  return api.get("/rockstar/admin/faq-categories", { params });
};

// Delete FAQ Category by ID
export const deleteFaqCategory = (id) => {
  return api.delete(`/rockstar/admin/faq-category/${id}`);
};

// =============================
// FAQ API ENDPOINTS
// =============================

// Create (Add) a new FAQ
export const createFaq = (data) => {
  // expected payload:
  // { question, answer, categoryId, isPublished, order, metadata(optional) }
  return api.post("/rockstar/admin/faq", data);
};

// Get all FAQs (Admin)
export const getAllFaqsAdmin = (params = {}) => {
  // optional params: { limit, offset, search, categoryId, isPublished }
  return api.get("/rockstar/admin/faqs", { params });
};

// Delete FAQ by ID
export const deleteFaq = (id) => {
  return api.delete(`/rockstar/admin/faq/${id}`);
};

// Update FAQ (optional for future use)
export const updateFaq = (id, data) => {
  return api.put(`/rockstar/admin/faq/${id}`, data);
};


// =============================
// TESTIMONIAL API ENDPOINTS
// =============================

// Create Testimonial
export const createTestimonial = (data) => {
  // Expected: { name, review, isActive? }
  return api.post("/rockstar/admin/testimonial", data);
};

// Get All Testimonials (Admin)
export const getAllTestimonialsAdmin = (params = {}) => {
  // Optional params: { limit, offset, search, isActive }
  return api.get("/rockstar/admin/testimonials", { params });
};

//  Get Single Testimonial (by ID)
export const getTestimonialById = (id) => {
  return api.get(`/rockstar/admin/testimonial/${id}`);
};

// Update Testimonial
export const updateTestimonial = (id, data) => {
  // Expected: { name?, review?, isActive? }
  return api.put(`/rockstar/admin/testimonial/${id}`, data);
};

// Delete (Soft Delete) Testimonial
export const deleteTestimonial = (id) => {
  return api.delete(`/rockstar/admin/testimonial/${id}`);
};


// =============================
// INTEGRATION SETTINGS API
// =============================

// GET current integration settings (admin)
export const getIntegrationSettings = () => {
  return api.get("/rockstar/admin/integrations");
};

// PUT update (create-if-not-exist)
export const updateIntegrationSettings = (data) => {
  return api.put("/rockstar/admin/integrations", data);
};

// Optional helpers:
export const createIntegrationSettings = (data) => {
  return api.post("/rockstar/admin/integrations", data);
};

export const deleteIntegrationSettings = (id) => {
  return api.delete(`/rockstar/admin/integrations/${id}`);
};

export const createBlogCategory = (data) => api.post("/rockstar/admin/blog-categories", data);
export const getAllBlogCategoriesAdmin = (params) => api.get("/rockstar/admin/blog-categories", { params });
export const deleteBlogCategory = (id) => api.delete(`/rockstar/admin/blog-categories/${id}`);



// BLOG
export const createBlog = (formData) =>
  api.post("/rockstar/admin/blogs", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });

  // GET all blogs (admin)
export const getAllBlogsAdmin = (params) =>
  api.get("/rockstar/admin/blogs", { params });

// DELETE a blog (admin)
export const deleteBlog = (id) =>
  api.delete(`/rockstar/admin/blogs/${id}`);


export const updateBlog = (id, formData) =>
  api.put(`/rockstar/admin/blogs/${id}`, formData, { headers: { "Content-Type": "multipart/form-data" } });

// create banner (multipart)
export const createBanner = (formData) =>
  api.post("/rockstar/admin/banners", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });

// update banner (multipart)
export const updateBanner = (id, formData) =>
  api.put(`/rockstar/admin/banners/${id}`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });

export const getBanners = (params) =>
  api.get("/rockstar/admin/banners", { params });

export const deleteBanner = (id) =>
  api.delete(`/rockstar/admin/banners/${id}`);


export const updateUserByAdmin = (id, data) => api.put(`/rockstar/admin/users/${id}`, data);

// Delete user by admin
export const deleteUserByAdmin = (id) => api.delete(`/rockstar/admin/users/${id}`);

export const getUserById = (id) => api.get(`/rockstar/admin/users/${id}`);

// =============================
// TELEGRAM PACKAGES API ENDPOINTS
// =============================

// Create a new Telegram Package
export const createTelegramPackage = (data) => {
  // Expected payload: same as AddTelegramPackage.jsx form
  return api.post("/rockstar/admin/telegram-packages/add", data);
};

// Get all Telegram Packages (Admin)
export const getAllTelegramPackagesAdmin = (params = {}) => {
  // optional: { limit, search, page }
  return api.get("/rockstar/admin/telegram-packages/list", { params });
};

// Delete a Telegram Package by ID
export const deleteTelegramPackage = (id) => {
  return api.delete(`/rockstar/admin/telegram-packages/${id}`);
};

// Update a Telegram Package
export const updateTelegramPackage = (id, data) => {
  return api.put(`/rockstar/admin/telegram-packages/${id}`, data);
};


// ================== Festival / Greetings ==================

// Public: get the current festival message shown on the site
export const getCurrentFestival = () =>
  api.get('/rockstar/current-festival')

// Admin: set/update the festival message (body: { message: string })
export const setCurrentFestival = (message) =>
  api.post('/rockstar/admin/current-festival', { message })

